(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-article"]) return;
  try {
    
(function(){
  var root=document.querySelector('[data-journal]');
  if(!root)return;

  var bar=root.querySelector('[data-journal-progress]');
  function updateProgress(){
    if(!bar)return;
    var doc=document.documentElement;
    var max=Math.max(1,doc.scrollHeight-window.innerHeight);
    var pct=Math.min(100,Math.max(0,(window.scrollY/max)*100));
    bar.style.width=pct+'%';
  }
  updateProgress();
  window.addEventListener('scroll',updateProgress,{passive:true});
  window.addEventListener('resize',updateProgress);

  var content=root.querySelector('[data-journal-content]');
  var toc=root.querySelector('[data-journal-toc]');
  if(!content||!toc)return;
  var headings=Array.prototype.slice.call(content.querySelectorAll('h2,h3')).slice(0,12);
  headings.forEach(function(heading,index){
    if(!heading.id)heading.id='journal-section-'+(index+1);
    var link=document.createElement('a');
    link.href='#'+heading.id;
    link.textContent=heading.textContent;
    link.dataset.target=heading.id;
    toc.appendChild(link);
  });
  if(!headings.length)toc.parentElement.hidden=true;

  if('IntersectionObserver' in window&&headings.length){
    var links=Array.prototype.slice.call(toc.querySelectorAll('a'));
    var observer=new IntersectionObserver(function(entries){
      entries.forEach(function(entry){
        if(entry.isIntersecting){
          links.forEach(function(link){link.classList.toggle('is-active',link.dataset.target===entry.target.id)});
        }
      });
    },{rootMargin:'-20% 0px -65% 0px',threshold:0});
    headings.forEach(function(heading){observer.observe(heading)});
  }
})();

  } catch(e) { console.error(e); }
})();
})();
